import type { ImageField } from '@prismicio/client';
import styles from './serviceImageList.module.scss';
import { ServiceImage } from './ServiceImage/ServiceImage';

interface ServiceImageListProps {
  images: ImageField<never>[];
  activeItem: number;
  isVisible: boolean;
}

export const ServiceImageList = ({
  images,
  activeItem,
  isVisible,
}: ServiceImageListProps) => {
  return (
    <ul className={`${styles.list} ${isVisible ? styles.isVisible : ''}`}>
      {images.map((image, index) => (
        <ServiceImage
          image={image}
          isActive={index === activeItem}
          key={image.id}
        />
      ))}
    </ul>
  );
};
